module.exports = __webpack_public_path__ + "img/logo-kiosk.75e6ea1c.png";